import { render, staticRenderFns } from "./Boleto.vue?vue&type=template&id=2e3983c2&lang=html&"
import script from "./Boleto.vue?vue&type=script&lang=js&"
export * from "./Boleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports